
<template>
	<div id="idMainCloud" ref="idMainCloud" style="display:flex; flex-direction:column; width:100%; height:100%; border:0px solid blue; background-color:#1c77ac; background-image:url(../static/aiphoto_images/bg_light.png); background-repeat:no-repeat; background-position:center top; overflow:hidden;">
		<div id="cloud1" ref="cloud1" class="cloud"></div>
      	<div id="cloud2" ref="cloud2" class="cloud"></div>

		<div style="flex:0 0 auto; border:0px solid red; width:100%; height:80px; display:flex; flex-direction:row;">

		</div>
		<div style="flex:1 1 auto; border:0px solid red; width:100%; display:flex; flex-direction:row; background:url(../static/aiphoto_images/bg_bg3.png) no-repeat center center; z-index:999;">
			<div style="flex:1 1 auto; border:0px solid blue; height:100%;"></div>
			<div style="flex:0 0 auto; border:0px solid blue; height:100%; width:500px; display:flex; flex-direction:row; align-items:center; justify-content:center;">
				<div id="idLoginFrm" ref="idLoginFrm" style="display:flex; flex-direction:row; border:1px solid var(--clrBG1);">
					<div style="flex:0 0 auto; border:0px solid red; width:50px; height:100%;"></div>
					<div style="flex:1 0 auto; border:0px solid red; height:100%; display-flex; flex-direction:row;">
						<div style="flex:0 0 auto; width:100%; height:20px; border:0px solid blue;"></div>
						<div style="flex:0 0 auto; width:100%; height:30px; border:0px solid blue; font-size:24px; text-align:center;" :style="{'letter-spacing':ls1+'px'}" ctxt="AIPHOTO管理平台" class="DIVNoSelect"></div>
						<div style="flex:0 0 auto; width:100%; height:20px; border:0px solid blue;"></div>
						<div style="flex:0 0 auto; width:90%; height:42px; border:0px solid blue; display:flex; flex-direction:row;">
							<div style="flex:0 0 auto; width:40px; height:40px; border:0px solid red;">
								<div style="width:20px; height:20px; margin-left:10px; margin-top:10px; background:url(../static/images/name.png); background-size:100% 100%;"></div>
							</div>
							<input id="idLoginAcct" ref="idLoginAcct" type="text" maxlength="16"     v-model="inpAcct" style="float:left; width:100%; height:32px; margin-top:2px; letter-spacing:1px; font-size:20px;" cpla="账号" @keyup="onEnterPasd">
						</div>
						<div style="flex:0 0 auto; width:100%; height:20px; border:0px solid blue;"></div>
						<div style="flex:0 0 auto; width:90%; height:42px; border:0px solid blue; display:flex; flex-direction:row;">
							<div style="flex:0 0 auto; width:40px; height:40px; border:0px solid red;">
								<div style="width:20px; height:20px; margin-left:10px; margin-top:10px; background:url(../static/images/password.png); background-size:100% 100%;"></div>
							</div>
							<input id="idLoginPasd" ref="idLoginPasd" type="password" maxlength="16" v-model="inpPswd" style="float:left; width:100%; height:32px; margin-top:2px; letter-spacing:1px; font-size:20px;" cpla="密码" @keyup="onEnterLogin">
						</div>
						<div style="flex:0 0 auto; width:100%; height:20px; border:0px solid blue;"></div>
						<div style="flex:0 0 auto; width:90%; height:42px; border:0px solid blue; display:flex; flex-direction:row;">
							<div style="flex:0 0 auto; width:40px; height:40px; border:0px solid red;">
								<div style="width:20px; height:20px; margin-left:10px; margin-top:10px;"></div>
							</div>
							<input id="idVCode" ref="idVCode" type="text" maxlength="5" v-model="inpVcode" style="float:left; width:170px; height:32px; margin-top:2px; letter-spacing:1px; font-size:20px;" cpla="验证码" @keyup="onEnterVcode">
							<img id="idVCodeImg" ref="idVCodeImg" style="width:120px; height:40px; border:0px solid red; margin-top:0px; margin-left:20px;" src="" @click="getVerifyCode()">
						</div>
						<div style="flex:0 0 auto; width:100%; height:20px; border:0px solid blue;"></div>
						<div style="flex:0 0 auto; width:90%; height:42px; border:0px solid blue; display:flex; flex-direction:row;">
							<div style="flex:0 0 auto; width:40px; height:40px; border:0px solid red;"></div>
							<div class="DIVBtn" style="flex:1 0 auot; width:100%; text-indent:10px; height:42px; line-height:42px;" :style="{'letter-spacing':ls1+'px'}" @click="onLoginClick" ctxt="确定"></div>
						</div>
						<div style="flex:0 0 auto; width:100%; height:42px; border:0px solid blue;">
							<cselect style="float:right; position:relative; margin-top:20px; height:30px; min-width:150px; z-index:999;" :onchange="onLangChange" :defv="cLan" v-model="cLan" :ctrl="ctrlLang" :csData="dataLang"></cselect>
						</div>
					</div>
					<div style="flex:0 0 auto; border:0px solid red; width:50px; height:100%;"></div>
				</div>
			</div>
			<div style="flex:1 1 auto; border:0px solid blue; height:100%;"></div>
		</div>
		<div style="flex:0 0 auto; border:0px solid red; width:100%; height:80px; color:#ffffff;">
			<div style="width:100%; color:#ffffff; text-align:center; font-size:18px; border:1px solid transparent; height:45px;"><pre></pre></div>
			<table style="width:100%;"><tr><td id="idAppVer" ref="idAppVer" style="text-align:right; border:1px solid transparent; width:50%; padding-right:20px;">{{AppVer}}</td><td id="idSrvVer" ref="idSrvVer" style="border:1px solid transparent; width:50%; padding-left:20px;">{{SerVer}}</td></tr></table>
		</div>
	</div>
</template>

<script>

import Vue from 'vue'
import cselect    from './cf/cselect'

/* 登录信息对象 */
Vue.prototype.login={
	custId: "",            // 客户ID
	custName: "",          // 客户名称
	userId: "",            // 用户ID
	userType: "",          // 用户类型
	userName: "",          // 用户姓名
	userAcct: "",          // 登录账号
	token: "",             // 登录后得到的token
}

export default {
	name: 'Login',
	components:{
		cselect
	},
	data () {
		return {
			vrnd: "",
			mainWidth: 0,
			cloudOffset1: 450,
			cloudOffset2: 0,
			bgOffset: 0,
			flutterFlag: true,
			cLan: gLan,
			ctrlLang: {
				itemHeight: 26,
				bgClr: "#ffffff",
				bodr: "#cccccc",
				expandEmp: false,
				size: 10
			},
			dataLang:[
					{ itemName:"中文",      itemValue:"0",    subItems:[] },
					{ itemName:"English",   itemValue:"1",    subItems:[] },
				],

			ls1: gLS1,                                 // 按钮、标题字符间距
			AppVer: "web: "+gAppVer,                   // 前端版本
			SerVer: "server: ",                        // 平台版本, 通过交易获取
			inpPswd: "",                               // 登录密码
			inpAcct: "",                               // 登录用户名
			inpVcode: "",                              // 验证码
		}
	},
	watch:{

	},
	mounted: function(){
		this.setTextByLan();

		this.mainWidth = this.$refs["idMainCloud"].offsetWidth;
		setInterval( this.flutter1, 70);
		setInterval( this.flutter2, 90 );

		this.getVerifyCode();
		setTimeout( this.getServVer, 50 );
	},
	computed:{

	},
	methods:{
		/* 飘动 */
		flutter1: function() {
			if( this.flutterFlag==false ) return;

	        if (this.cloudOffset1 >= this.mainWidth) { this.cloudOffset1 =  -405; }
	        if (this.cloudOffset2 >= this.mainWidth) { this.cloudOffset2 =  -405; }

	        this.cloudOffset1 += 1.1;
			this.cloudOffset2 += 1;

	        if( this.$refs["cloud1"] ) this.$refs["cloud1"].style["background-position"] = this.cloudOffset1 + "px 100px";
			if( this.$refs["cloud2"] ) this.$refs["cloud2"].style["background-position"] = this.cloudOffset2 + "px 460px";
	    },
	    flutter2: function bg() {
	    	if( this.flutterFlag==false ) return;

	        if (this.bgOffset >= this.mainWidth ) { this.bgOffset =  -1522; }

	        this.bgOffset += 0.9;
	        if( this.$refs["idMainCloud"] ) this.$refs["idMainCloud"].style["background-position"] = (-this.bgOffset) + "px 0";
	    },
	    onLangChange: function( lan ){
	    	gLan = lan;
	    	sessionStorage.setItem( "FunsbootLang", JSON.stringify( {curLan: gLan} ) );
			this.setTextByLan();
	    },
		/* 生成验证码 */
		getVerifyCode: function(){
			this.vrnd = 100000 + parseInt(Math.random()*100000);
			this.$refs["idVCodeImg"].src = ServAddr+'/api/pub/vcodeImg?vrnd=' + this.vrnd;
		},
		/* 子组件的 onresize 处理 */
		onResize: function(){
			this.childResize( this );
		},
		/* 账号输入框响应回车按键 */
		onEnterPasd: function( event ){
			if( event.keyCode == 13 ) this.$refs["idLoginPasd"].focus();
		},
		/* 密码输入框响应回车按键 */
		onEnterLogin: function( event ){
			if( event.keyCode == 13 ) this.$refs["idVCode"].focus();
		},
		/* 验证码输入框响应回车键 */
		onEnterVcode: function( event ){
			if( event.keyCode == 13 ) this.onLoginClick();
		},
		/* 登录 */
		onLoginClick: function(){
			if( (this.inpAcct.length) < 3 || (this.inpPswd < 3) || (this.inpVcode.length < 4) )
			{
					 if( this.inpAcct.length < 3 )
					 this.appRoot.app.showDlgTip( 1200, LangText("账号长度不足"), this.CLR.Err );
				else if(this.inpPswd < 3)
					 this.appRoot.app.showDlgTip( 1200, LangText("密码长度不足"), this.CLR.Err );
				else this.appRoot.app.showDlgTip( 1200, LangText("验证码长度不足"), this.CLR.Err );
				return;
			}

			this.login.userAcct = this.inpAcct;
			let body={userAcct:this.inpAcct,userPswd:this.inpPswd, vcode:this.inpVcode, vrnd: this.vrnd};
			this.doTrade( "POST", ServAddr+"/api/user/userLogin", this.onLoginOK, true, body, null );
		},
		onLoginOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code != 200 )
			{
				this.vrnd = 100000 + parseInt(Math.random()*100000);
				this.appRoot.app.showDlgTip( 2000, this.getErrorText(data.code), this.CLR.Err );
				this.$refs["idVCodeImg"].src = ServAddr+'/api/pub/vcodeImg?vrnd=' + this.vrnd;
				return;
			}

			let info=data.body;
			this.login.userAcct      = this.inpAcct;
			this.login.custId        = info.custId;
			this.login.custName      = this.isNullAs(info.custName, "");
			this.login.userId        = info.userId;
			this.login.userType      = info.userType;
			this.login.userName      = info.userName;
			this.login.token         = info.token;
			this.login.custAiTimes   = info.custAiTimes;
			this.login.custAiFlag    = info.custAiFlag;
			this.login.custAiBalance = info.custAiBalance;
			this.login.custAiHighPrice = info.custAiHighPrice;
			this.login.custAlarmTimes  = info.custAlarmTimes;

			this.flutterFlag = false;
			this.$parent.$refs["idFormLogin"].style["display"] = "none";
			this.$parent.$refs["idMainL1" ].style["display"] = "block";

			this.$parent.$refs["idMainMenu"].loadMenu();

			this.$parent.updateTopbar();

			if( 0<(decodeURIComponent( window.location )).indexOf("?op=1023") && this.login.userAcct=="sysadmin" )
				 this.$router.push( "/FrameBody/custList" );
			else
			{
				if( this.login.custAiFlag==1 )
				{
					if( !this.login.custAlarmTimes )  this.login.custAlarmTimes = 100;
					if( !this.login.custAiHighPrice ) this.login.custAiHighPrice = 14;   // 以美元为单位(单位是分)
					console.log( this.login.custAiFlag , this.login.custAiBalance, this.login.custAiHighPrice );
					this.login.custAiTimes = parseInt((this.login.custAiBalance+this.login.custAiHighPrice-1) / this.login.custAiHighPrice);

					if( this.login.custAiTimes<this.login.custAlarmTimes )
						 this.$router.push( "/FrameBody/aiInfo" );
					else this.$router.push( "/FrameBody/DataCube" );
				}
				else this.$router.push( "/FrameBody/DataCube" );
			}
		},
		/* 获取服务器后端软件版本 */
		getServVer: function(){
			this.doTrade( "POST", ServAddr+"/api/pub/servVer", this.getServVerOK, false, null, null );
		},
		getServVerOK: function( res ){
			let data=res.body;
			if( data.code == 200 )
			{
				this.SerVer = "server: "+data.body.servVer;
			}
		},
	}
}

</script>

<style scoped>
#idLoginFrm{height:370px; width:100%; background:#ffffff; border-radius:9px;}

.cloud {position:absolute;top:0px;left:0px;width:100%;height:100%;background:url(../static/aiphoto_images/bg_cloud.png) no-repeat;z-index:1;opacity:0.5;}
#cloud2 {z-index:2;}

.BeiAn{ color:#ffffff; text-decoration:none; }
.BeiAn:hover{ color:#2fd7ef;}

</style>



// WEBPACK FOOTER //
// login.vue?60c279b6